@ -0,0 +1,893 @@
<template>
  <div class="premios-container">
    <VueFinalModal
      v-model="showRedeemForm"
      :esc-to-close="false"
      class="modal-container"
      content-class="modal-content"
    >
      <div class="modal__content">
        <div class="row">
          <div class="col-11 col-sm-11 col-md-11 col-xl-11 col-lg-11"></div>
          <div
            class="col-1 col-sm-1 col-md-1 col-xl-1 col-lg-1"
            style="padding: 0; display: flex; justify-content: center"
            @click="closeRedeemForm"
          >
            <i class="fas fa-times-square close_modal"></i>
          </div>
        </div>
        <h5 class="text-center mb-4">Formulario de Canje de Premio</h5>
        <form @submit.prevent="submitRedeemForm">
          <div class="row">
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Nombre completo
              </label>
              <input
                required
                placeholder="Nombre completo"
                class="form-control"
                type="text"
                v-model="redeemForm.fullName"
              />
            </div>
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Cédula
              </label>
              <input
                required
                placeholder="Cédula"
                class="form-control"
                type="text"
                v-model="redeemForm.dni"
              />
            </div>
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Teléfono
              </label>
              <input
                required
                placeholder="Teléfono"
                class="form-control"
                type="tel"
                v-model="redeemForm.phone"
              />
            </div>
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Email
              </label>
              <input
                required
                placeholder="Email"
                class="form-control"
                type="email"
                v-model="redeemForm.email"
              />
            </div>
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Dirección completa
              </label>
              <input
                required
                placeholder="Dirección completa"
                class="form-control"
                type="text"
                v-model="redeemForm.address"
              />
            </div>
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Referencias
              </label>
              <textarea
                required
                placeholder="Referencias de ubicación"
                class="form-control"
                rows="3"
                v-model="redeemForm.references"
              ></textarea>
            </div>
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Premio
              </label>
              <input
                class="form-control"
                type="text"
                :value="selectedPrizeName"
                disabled
              />
            </div>
            <div class="col-12 mb-2">
              <label class="form-control-label" style="font-weight: bold">
                Fecha
              </label>
              <input
                class="form-control"
                type="text"
                :value="currentDate"
                disabled
              />
            </div>
            <div class="col-12 text-center mt-3">
              <button
                type="submit"
                class="btn btn-primary btn-lg w-100"
                :disabled="isSubmitting"
              >
                {{ isSubmitting ? "Enviando..." : "Enviar solicitud" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </VueFinalModal>

    <div class="rouletteParentContainer">
      <div
        v-if="!loadingRouletteItems && !isRouletteEnabled"
        class="roulette-info-message"
      >
        <div class="info-message-container">
          <i class="fas fa-info-circle info-icon"></i>
          <p class="info-text">
            La ruleta está desactivada momentáneamente. Estaremos de vuelta
            pronto.
          </p>
        </div>
      </div>

      <template v-else-if="isRouletteEnabled">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p class="blueText">Haz click en la Ruleta</p>
        </div>
        <div class="roulette-container">
          <img
            src="../../assets/img/Saludsa/arrow.webp"
            class="gold-arrow"
            :style="{
              width: arrowSize + 'px',
              height: 'auto',
              top: arrowTop + 'px',
            }"
          />
          <div class="roulette-red">
            <div class="roulette-gold">
              <Roulette
                :key="wheelKey"
                class="custom-wheel"
                ref="wheel"
                :items="rouletteItems"
                @click="
                  availableSpins > 0 && !isSpinning ? launchWheel() : null
                "
                @wheel-start="wheelStartedCallback"
                @wheel-end="wheelEndedCallback"
                :display-indicator="true"
                :base-display-indicator="false"
                :centered-indicator="false"
                :base-display="true"
                :display-border="false"
                :horizontal-content="true"
                :base-display-shadow="true"
                :display-shadow="false"
                easing="ease"
                :size="wheelSize"
                base-background="#d61015"
                base-size="30"
                :duration="wheelSettings.duration"
                :first-item-index="wheelSettings.firstItemIndex"
                :wheel-result-index="wheelValue"
                :style="{
                  cursor:
                    availableSpins > 0 && !isSpinning
                      ? 'pointer'
                      : 'not-allowed',
                  opacity: availableSpins > 0 && !isSpinning ? 1 : 0.6,
                }"
              >
                <template #baseContent>
                  <div
                    class="arrow-roullete"
                    v-html="wheelSettings.baseHtmlContent"
                  />
                </template>
              </Roulette>
            </div>
          </div>
          <div class="blueDiv">
            <p class="whiteText">Giros</p>
            <div class="blueSquare">
              <p class="whiteText">{{ availableSpins }}</p>
            </div>
          </div>
        </div>
      </template>

      <!-- Loading state -->
      <div v-else-if="loadingRouletteItems" class="roulette-loading">
        <i class="fas fa-spinner fa-spin"></i>
        <p>Cargando ruleta...</p>
      </div>
    </div>

    <div class="card mt-4">
      <div class="card-body">
        <h5 class="card-title mb-4">Mis Premios</h5>
        <div class="row">
          <div v-if="loadingPrizes" class="col-12 text-center">
            <i class="fas fa-spinner fa-spin"></i> Cargando premios...
          </div>
          <div
            v-else-if="userPrizes.length === 0"
            class="col-12 text-center text-muted"
          >
            No has ganado ningún premio aún
          </div>
          <div
            v-for="prize in userPrizes"
            :key="prize.prizeId"
            class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4"
          >
            <div class="prize-card">
              <div class="prize-card-header">
                <i class="fas fa-trophy text-warning"></i>
                <span
                  class="prize-status-badge"
                  :class="getStatusClass(prize.status)"
                >
                  {{ getStatusText(prize.status) }}
                </span>
              </div>
              <div class="prize-card-body">
                <div class="prize-image-container">
                  <img
                    v-if="prize.imageUrl"
                    :src="prize.imageUrl"
                    :alt="prize.prizeName"
                    class="prize-image"
                    @error="handleImageError"
                  />
                  <div v-else class="prize-image-placeholder">
                    <i class="fas fa-trophy"></i>
                  </div>
                </div>
                <h6 class="prize-name">{{ prize.prizeName }}</h6>
                <div class="prize-status-item">
                  <span class="prize-status-label">Ganado:</span>
                  <span
                    class="prize-status-value"
                    :class="{ 'status-pending-text': !prize.createdAt }"
                  >
                    {{ formatDateOrPending(prize.createdAt) }}
                  </span>
                </div>
                <div class="prize-status-item">
                  <span class="prize-status-label">Solicitado:</span>
                  <span
                    class="prize-status-value"
                    :class="{ 'status-pending-text': !prize.redeemedAt }"
                  >
                    {{ formatDateOrPending(prize.redeemedAt) }}
                  </span>
                </div>
                <div class="prize-status-item">
                  <span class="prize-status-label">Enviado:</span>
                  <span
                    class="prize-status-value"
                    :class="{ 'status-pending-text': !prize.sentAt }"
                  >
                    {{ formatDateOrPending(prize.sentAt) }}
                  </span>
                </div>
                <div class="prize-status-item">
                  <span class="prize-status-label">Entregado:</span>
                  <span
                    class="prize-status-value"
                    :class="{ 'status-pending-text': !prize.deliveredAt }"
                  >
                    {{ formatDateOrPending(prize.deliveredAt) }}
                  </span>
                </div>
              </div>
              <div class="prize-card-footer">
                <button
                  v-if="prize.status === 'pending_redeem'"
                  class="btn btn-primary btn-sm w-100"
                  @click="openRedeemModal(prize)"
                >
                  Canjear Premio
                </button>
                <div v-else class="prize-info-text">
                  <small>{{ getStatusDescription(prize.status) }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Roulette } from "vue3-roulette";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import { JSEncrypt } from "jsencrypt";
import keys from "@/store/keys";

export default {
  name: "Premios",
  components: {
    Roulette,
    VueFinalModal,
  },
  data() {
    const rand = Math.floor(Math.random() * 12) + 1;
    let datos = JSON.parse(localStorage.getItem("userData")) || {};
    return {
      wheelKey: 0,
      wheelSize: 300,
      arrowSize: 65,
      arrowTop: -22,
      availableSpins: 0,
      isSpinning: false,
      showRedeemForm: false,
      selectedPrizeName: "",
      selectedPrizeValue: null,
      currentPrizeId: null,
      isSubmitting: false,
      redeemForm: {
        fullName: datos.displayName || "",
        dni: "",
        phone: datos.phone || "",
        email: datos.email || "",
        address: "",
        references: "",
      },
      wheelValue: { value: Math.floor(Math.random() * 12) },
      wheelSettings: {
        centeredIndicator: true,
        indicatorPosition: "top",
        displayShadow: true,
        duration: 5,
        resultVariation: 70,
        easing: "ease",
        counterClockwise: true,
        horizontalContent: false,
        displayBorder: true,
        displayIndicator: true,
        baseDisplay: true,
        baseSize: 210,
        baseDisplayShadow: false,
        baseDisplayIndicator: true,
        baseBackground: "",
        baseHtmlContent: "",
        firstItemIndex: rand,
      },
      rouletteItems: [],
      userPrizes: [],
      loadingPrizes: false,
      loadingRouletteItems: false,
      loadingSpins: false,
      isRouletteEnabled: false,
      isAdmin: false,
      isSaludsa: false,
      isUser: false,
      /** Rol en claro: solo desde `localStorage.session` desencriptado */
      userRole: null,
      rouletteFlag: null,
    };
  },
  watch: {
    showRedeemForm(newVal, oldVal) {
      if (
        oldVal === true &&
        newVal === false &&
        this.currentPrizeId &&
        !this.isSubmitting
      ) {
        // Recargar la lista de premios para mostrar el nuevo premio
        this.loadUserPrizes();
        this.resetWheel();
      }
    },
  },
  methods: {
    decryptedRole() {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          this.isAdmin = false;
          this.isSaludsa = false;
          this.isUser = false;
          this.userRole = null;
          return;
        }
        const decrypt = new JSEncrypt();
        decrypt.setPrivateKey(keys.privateKeyBackoffice);
        const role = decrypt.decrypt(session);
        const roleStr = typeof role === "string" ? role.trim() : "";
        this.isAdmin = roleStr === "admin";
        this.isSaludsa = roleStr === "saludsa";
        this.isUser = roleStr === "user";
        this.userRole = roleStr || null;
      } catch (error) {
        console.error("[Premios] Error decrypting role:", error);
        this.isAdmin = false;
        this.isSaludsa = false;
        this.isUser = false;
        this.userRole = null;
      }
    },
    async loadRouletteFlag() {
      try {
        const res = await this.$https.get("/flags/roulette");
        if (res?.data?.code === 200) {
          this.rouletteFlag = res.data.data;
        } else {
          this.rouletteFlag = { roles: [] };
        }
      } catch (e) {
        this.rouletteFlag = { roles: [] };
      }
    },
    ensureAuthorized() {
      this.decryptedRole();
      const roles = Array.isArray(this.rouletteFlag?.roles)
        ? this.rouletteFlag.roles
        : [];
      const canSeeRoulette = !!(this.userRole && roles.includes(this.userRole));
      if (!canSeeRoulette) {
        this.$router.push("/dashboard");
        return false;
      }
      return true;
    },
    async launchWheel() {
      // Validar que tenga spins disponibles
      if (this.availableSpins <= 0) {
        this.$swal({
          title: "Sin giros",
          text: "No tienes giros disponibles para girar la ruleta",
          icon: "warning",
          confirmButtonText: "ACEPTAR",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      // Validar que no esté girando
      if (this.isSpinning) {
        return;
      }

      // Restar el spin antes de girar
      try {
        const response = await this.$https.post("/balance/spins/use");

        if (response.data.code === 200) {
          // Actualizar el contador de spins
          this.availableSpins = response.data.spins || 0;

          // Iniciar el giro
          if (this.$refs.wheel) {
            this.isSpinning = true;
            this.wheelValue = { value: Math.floor(Math.random() * 12) };
            this.$refs.wheel.launchWheel();
          } else {
            console.error("The wheel reference is not set yet.");
          }
        } else {
          throw new Error(response.data.error || "Error al usar el spin");
        }
      } catch (error) {
        console.error("Error al usar el spin:", error);
        this.$toast.error(
          error.response?.data?.error || "Ocurrió un error al iniciar el giro",
          {
            position: "top-right",
            max: 10,
          },
        );
        // Recargar spins por si hubo algún problema
        await this.loadSpins();
      }
    },
    wheelStartedCallback() {
      this.isSpinning = true;
      console.log("Ruleta iniciada");
    },
    wheelEndedCallback() {
      this.isSpinning = false;
      if (this.$refs.wheel && this.$refs.wheel.itemSelected) {
        const selectedItem = this.$refs.wheel.itemSelected;
        console.log("Premio seleccionado:", selectedItem);

        if (selectedItem.value) {
          this.selectedPrizeName = selectedItem.name;
          this.selectedPrizeValue = selectedItem.value;

          this.createPrizeRecord(selectedItem);
        } else {
          // El spin ya se restó cuando se inició el giro
          this.$swal({
            title: "¡Sigue participando!",
            text: "Inténtalo de nuevo en la próxima oportunidad",
            icon: "info",
            confirmButtonText: "ACEPTAR",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          }).then(() => {
            this.resetWheel();
          });
        }
      }
    },
    resetWheel() {
      this.wheelKey += 1;
    },
    getWheelSize(screenWidth) {
      if (screenWidth > 1200) return 430;
      if (screenWidth > 991) return 410;
      if (screenWidth > 800) return 430;
      if (screenWidth > 600) return 430;
      if (screenWidth > 400) return 320;
      if (screenWidth > 330) return 270;
      return 230;
    },
    getArrowSize(screenWidth) {
      if (screenWidth > 1200) return 65;
      if (screenWidth > 991) return 65;
      if (screenWidth > 800) return 65;
      if (screenWidth > 600) return 65;
      if (screenWidth > 400) return 62;
      return 55;
    },
    getArrowTop(screenWidth) {
      if (screenWidth > 1200) return -22;
      if (screenWidth > 991) return -21;
      if (screenWidth > 800) return -22;
      if (screenWidth > 600) return -21;
      if (screenWidth > 400) return -17;
      if (screenWidth > 330) return -8;
      return -8;
    },
    handleResize() {
      this.wheelSize = this.getWheelSize(window.innerWidth);
      this.arrowSize = this.getArrowSize(window.innerWidth);
      this.arrowTop = this.getArrowTop(window.innerWidth);
    },
    async createPrizeRecord(selectedItem) {
      try {
        const response = await this.$https.post("/prize/win", {
          prizeId: selectedItem.prizeId || selectedItem.id,
          prizeName: selectedItem.name,
        });

        if (response.data.code === 201) {
          this.currentPrizeId = response.data.data.prizeId;

          // El spin ya se restó cuando se inició el giro, no necesitamos actualizar aquí

          this.$swal({
            title: "¡Felicidades!",
            html: `<div class="prizeDiv">
              <p class="prizeTextModal"><strong>Ganaste: ${selectedItem.name}</strong></p>
            </div>`,
            icon: "success",
            confirmButtonText: "CANJEAR PREMIO",
            customClass: {
              confirmButton: "btn btn-primary",
              popup: "congratulations-modal",
            },
            buttonsStyling: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              const userData =
                JSON.parse(localStorage.getItem("userData")) || {};
              this.redeemForm.fullName = `${userData.displayName || ""} ${
                userData.lastName || ""
              }`.trim();
              this.redeemForm.dni = userData.dni || "";
              this.redeemForm.phone = userData.phone || "";
              this.redeemForm.email = userData.email || "";
              this.showRedeemForm = true;
            } else {
              this.loadUserPrizes();
              this.resetWheel();
            }
          });
        } else {
          throw new Error(response.data.error || "Error al crear premio");
        }
      } catch (error) {
        console.error("Error al crear el premio:", error);

        // Si el error es por falta de spins, actualizar el contador
        if (
          error.response?.data?.code === 400 &&
          error.response?.data?.error?.includes("giros")
        ) {
          await this.loadSpins();
        }

        this.$toast.error(
          error.response?.data?.error ||
            "Ocurrió un error al registrar el premio",
          {
            position: "top-right",
            max: 10,
          },
        );
        this.resetWheel();
      }
    },
    async loadSpins() {
      this.loadingSpins = true;
      try {
        const response = await this.$https.get("/balance/spins");

        if (response.data.code === 200) {
          this.availableSpins = response.data.spins || 0;
        } else {
          // Si hay error, setear en 0
          this.availableSpins = 0;
        }
      } catch (error) {
        console.error("Error al cargar spins:", error);
        // Si hay error, setear en 0
        this.availableSpins = 0;
      } finally {
        this.loadingSpins = false;
      }
    },
    closeRedeemForm() {
      const hadPrizeId = !!this.currentPrizeId;
      this.showRedeemForm = false;
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      this.redeemForm = {
        fullName:
          `${userData.displayName || ""} ${userData.lastName || ""}`.trim(),
        dni: userData.dni || "",
        phone: userData.phone || "",
        email: userData.email || "",
        address: "",
        references: "",
      };
      this.selectedPrizeName = "";
      this.selectedPrizeValue = null;
      this.currentPrizeId = null;
      this.isSubmitting = false;
      if (hadPrizeId) {
        this.loadUserPrizes();
      }
      this.resetWheel();
    },
    async submitRedeemForm() {
      this.isSubmitting = true;

      try {
        const redeemData = {
          fullName: this.redeemForm.fullName,
          dni: this.redeemForm.dni,
          phone: this.redeemForm.phone,
          email: this.redeemForm.email,
          address: this.redeemForm.address,
          references: this.redeemForm.references,
        };

        const response = await this.$https.put(
          `/prize/${this.currentPrizeId}/redeem`,
          {
            redeemData: redeemData,
          },
        );

        if (response.data.code === 200) {
          this.$swal({
            title: "¡Éxito!",
            text: "Tu solicitud de canje ha sido enviada correctamente",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          }).then(() => {
            this.loadUserPrizes();
            this.currentPrizeId = null;
            this.selectedPrizeName = "";
            this.selectedPrizeValue = null;
            this.closeRedeemForm();
          });
        } else {
          throw new Error(response.data.error || "Error al canjear premio");
        }
      } catch (error) {
        console.error("Error al canjear el premio:", error);
        this.$toast.error(
          error.response?.data?.error ||
            "Ocurrió un error al enviar la solicitud",
          {
            position: "top-right",
            max: 10,
          },
        );
        this.isSubmitting = false;
      }
    },
    openRedeemModal(prize) {
      this.currentPrizeId = prize.prizeId;
      this.selectedPrizeName = prize.prizeName;
      this.selectedPrizeValue = prize.prizeValue;

      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      this.redeemForm.fullName = `${userData.displayName || ""} ${
        userData.lastName || ""
      }`.trim();
      this.redeemForm.dni = userData.dni || "";
      this.redeemForm.phone = userData.phone || "";
      this.redeemForm.email = userData.email || "";

      this.showRedeemForm = true;
    },
    getStatusText(status) {
      const statusMap = {
        pending_redeem: "Pendiente de canje",
        redeem_requested: "Canje solicitado",
        sent: "Enviado",
        delivered: "Entregado",
      };
      return statusMap[status] || status;
    },
    getStatusClass(status) {
      const classMap = {
        pending_redeem: "status-pending",
        redeem_requested: "status-requested",
        sent: "status-sent",
        delivered: "status-delivered",
      };
      return classMap[status] || "";
    },
    getStatusDescription(status) {
      const descriptionMap = {
        pending_redeem: "Pendiente de canje",
        redeem_requested: "Tu solicitud está en proceso",
        sent: "Tu premio ha sido enviado",
        delivered: "Premio entregado exitosamente",
      };
      return descriptionMap[status] || "";
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateOrPending(dateString) {
      if (!dateString) return "Pendiente";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    handleImageError(event) {
      event.target.src =
        "https://via.placeholder.com/300x300?text=Imagen+no+disponible";
    },
    async loadRouletteItems() {
      this.loadingRouletteItems = true;
      try {
        const response = await this.$https.get("/prize/wheel/items");

        if (response.data.code === 200) {
          const payload = response.data.data;
          const prizes = Array.isArray(payload)
            ? payload
            : payload?.prizes || [];
          const settings = payload?.settings || {};
          const allowsFailedSpin = settings.allowsFailedSpin !== false;

          if (prizes.length === 6) {
            this.isRouletteEnabled = true;

            const items = [];
            if (allowsFailedSpin) {
              prizes.forEach((prize, index) => {
                items.push({
                  id: prize.id || index * 2 + 1,
                  name: prize.name,
                  htmlContent: `<span class="prize-text">${prize.name}</span>`,
                  textColor: "#ffffff",
                  background: "#0075d2",
                  value: prize.value,
                });
                items.push({
                  id: `continue-${index}`,
                  name: "Sigue participando",
                  htmlContent: `<span class="continue-text">¡Sigue participando!</span>`,
                  textColor: "#333333",
                  background: "#ffffff",
                  value: null,
                });
              });
            } else {
              for (let r = 0; r < 2; r++) {
                prizes.forEach((prize, index) => {
                  const isEvenSlot = items.length % 2 === 0;
                  items.push({
                    id: `${prize.id}-${r}-${index}`,
                    prizeId: prize.id,
                    name: prize.name,
                    htmlContent: `<span class="prize-text">${prize.name}</span>`,
                    textColor: isEvenSlot ? "#ffffff" : "#333333",
                    background: isEvenSlot ? "#0075d2" : "#ffffff",
                    value: prize.value,
                  });
                });
              }
            }

            this.rouletteItems = items;
          } else {
            this.isRouletteEnabled = false;
            this.rouletteItems = [];
          }
        } else {
          throw new Error(
            response.data.error || "Error al cargar items de la ruleta",
          );
        }
      } catch (error) {
        console.error("Error al cargar items de la ruleta:", error);
        this.isRouletteEnabled = false;
        this.$toast.error(
          error.response?.data?.error ||
            "Error al cargar la configuración de la ruleta",
          {
            position: "top-right",
            max: 10,
          },
        );
      } finally {
        this.loadingRouletteItems = false;
      }
    },
    async loadUserPrizes() {
      this.loadingPrizes = true;
      try {
        const response = await this.$https.get("/prize/user/prizes");

        if (response.data.code === 200) {
          this.userPrizes = response.data.data || [];
        } else {
          throw new Error(response.data.error || "Error al cargar premios");
        }
      } catch (error) {
        console.error("Error al cargar premios del usuario:", error);
        if (error.response?.status !== 401) {
          this.$toast.error(
            error.response?.data?.error || "Error al cargar tus premios",
            {
              position: "top-right",
              max: 10,
            },
          );
        }
      } finally {
        this.loadingPrizes = false;
      }
    },
  },
  computed: {
    currentDate() {
      const now = new Date();
      return now.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  async mounted() {
    await this.loadRouletteFlag();
    if (!this.ensureAuthorized()) {
      return;
    }
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    await this.loadRouletteItems();
    await this.loadUserPrizes();
    await this.loadSpins();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  activated() {
    if (!this.ensureAuthorized()) {
      return;
    }
    if (this.$isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
  },
};
</script>

<style>
.rouletteParentContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

@media screen and (min-width: 401px) {
  .rouletteParentContainer {
    gap: 30px;
  }
}

.gold-arrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  transition:
    width 0.3s,
    height 0.3s;
}

.roulette-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 20px 0 20px;
  position: relative;
}

.roulette-red {
  border: 20px solid #d61015 !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 5px 5px 15px -5px #000;
}

.roulette-gold {
  background: radial-gradient(
      ellipse farthest-corner at right bottom,
      #fedb37 0%,
      #e5c542 8%,
      #a9681e 30%,
      #8a6e2f 40%,
      transparent 80%
    ),
    radial-gradient(
      ellipse farthest-corner at left top,
      #ffffff 0%,
      #ffffac 8%,
      #d1b464 25%,
      #5d4a1f 62.5%,
      #5d4a1f 100%
    );
  padding: 5px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-wheel .wheel-base-indicator::before {
  left: 50% !important;
}

.wheel-container-indicator::before {
  left: 50% !important;
  border-top: 20px solid #ceb263 !important;
}

.wheel-item {
  border: none !important;
}

.custom-wheel .wheel-border::after {
  background-image: none;
}

.custom-wheel .wheel-base-container {
  border: none !important;
}

.content.horizontal-content span {
  font-size: 13px;
  font-weight: 900;
  line-height: 1.2;
}

.prize-text {
  font-size: 14px !important;
  font-weight: 900;
}

.continue-text {
  font-size: 13px !important;
  font-weight: 900;
}

/* Media Queries for Font Size Adjustments */
@media screen and (min-width: 1201px) {
  .content.horizontal-content span {
    font-size: 20px;
  }
  .prize-text {
    font-size: 16px !important;
  }
  .continue-text {
    font-size: 15px !important;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .content.horizontal-content span {
    font-size: 18px;
  }
  .prize-text {
    font-size: 15px !important;
  }
  .continue-text {
    font-size: 14px !important;
  }
}

@media screen and (min-width: 801px) and (max-width: 991px) {
  .content.horizontal-content span {
    font-size: 18px;
  }
  .prize-text {
    font-size: 14px !important;
  }
  .continue-text {
    font-size: 13px !important;
  }
}

@media screen and (min-width: 601px) and (max-width: 800px) {
  .content.horizontal-content span {
    font-size: 16px;
  }
  .prize-text {
    font-size: 13px !important;
  }
  .continue-text {
    font-size: 12px !important;
  }
}

@media screen and (max-width: 600px) {
  .content.horizontal-content span {
    font-size: 14px;
  }
  .prize-text {
    font-size: 11px !important;
  }
  .continue-text {
    font-size: 11px !important;
  }
}

@media screen and (max-width: 400px) {
  .content.horizontal-content span {
    font-size: 12px;
  }
  .prize-text {
    font-size: 10px !important;
  }
  .continue-text {
    font-size: 10px !important;
  }
}

@media screen and (max-width: 330px) {
  .content.horizontal-content span {
    font-size: 10px;
  }
  .prize-text {
    font-size: 9px !important;
  }
  .continue-text {
    font-size: 9px !important;
  }
}

.wheel .content.horizontal-content span {
  width: max-content !important;
  text-align: -webkit-center !important;
}

.wheel .content.horizontal-content {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;
  right: 86% !important;
  padding: 0 !important;
}

.blueDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  background: #0075d2;
  background: linear-gradient(68deg, #0075d2 0%, #005fa3 100%);
  border: 2px solid #004d82;
  color: white;
  margin: 0;
  width: max-content;
  border-radius: 16px;
  gap: 8px;
  align-self: flex-end;
  margin-top: 16px;
  font-weight: 900;
}

.blueText {
  padding: 5px 10px;
  background: #0075d2;
  background: linear-gradient(68deg, #0075d2 0%, #005fa3 100%);
  border: 2px solid #004d82;
  color: white;
  margin: 0;
  width: max-content;
  border-radius: 16px;
  gap: 8px;
  margin-top: 8px;
  font-weight: 900;
  font-size: 16px;
}

.whiteText {
  margin: 0;
  color: white;
  font-size: 16px;
  font-weight: 900;
}

.whiteTextPrize {
  margin: 0;
  color: white;
  font-size: 24px;
  padding: 5px 5px;
  border-radius: 8px;
  font-weight: 900;
}

.prizeTextModal {
  margin: 0;
  color: #333333;
  font-size: 18px;
  padding: 10px 0;
  font-weight: 700;
}

.prizeTextModal strong {
  font-weight: 700;
}

.congratulations-modal {
  padding: 2rem !important;
}

.congratulations-modal .swal2-title {
  margin-bottom: 1rem !important;
  font-size: 1.5rem !important;
}

.congratulations-modal .swal2-html-container {
  margin: 1rem 0 !important;
  padding: 0 !important;
}

.congratulations-modal .swal2-icon {
  margin-bottom: 1rem !important;
}

.blueSquare {
  display: flex;
  padding: 0 5px;
  justify-content: center;
  align-items: center;
  min-width: 24px;
  background-color: #154c85;
  border: 1px solid white;
  border-radius: 7px;
  aspect-ratio: 1/1;
}

.darkBlueText {
  margin: 0;
  color: #004d82;
  font-size: 16px;
  font-weight: 900;
}

.prizeDiv {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.crownStyle {
  height: 120px;
  margin: -57px 0 0 0;
}

.popupStyle {
  border: 6px solid #0075d2 !important;
  border-radius: 18px !important;
}

@keyframes scaleAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

.scaling-image {
  animation: scaleAnimation 1.5s ease-in-out infinite;
}

.prize-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s ease;
  background: white;
}

.prize-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.prize-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.prize-card-header i {
  font-size: 24px;
}

.prize-status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-requested {
  background-color: #cfe2ff;
  color: #084298;
}

.status-sent {
  background-color: #d1e7dd;
  color: #0f5132;
}

.status-delivered {
  background-color: #d4edda;
  color: #155724;
}

.prize-card-body {
  flex: 1;
  margin-bottom: 12px;
}

.prize-image-container {
  width: 100%;
  height: 200px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.prize-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.prize-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #999;
  font-size: 48px;
}

.prize-card:hover .prize-image {
  transform: scale(1.05);
}

.prize-name {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
  min-height: 40px;
}

.prize-status-item {
  margin: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.prize-status-label {
  font-weight: 700;
  color: #333;
  font-size: 14px;
}

.prize-status-value {
  color: #666;
  font-weight: 500;
  font-size: 14px;
  text-align: right;
}

.prize-status-value.status-pending-text {
  color: #999;
  font-style: italic;
  font-weight: 400;
}

.prize-card-footer {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.prize-info-text {
  text-align: center;
  color: #666;
  padding: 8px 0;
}

.roulette-info-message {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-message-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #0075d2;
}

.info-icon {
  font-size: 24px;
  color: #0075d2;
  flex-shrink: 0;
}

.info-text {
  color: #333333;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
}

.roulette-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  gap: 20px;
}

.roulette-loading i {
  font-size: 48px;
  color: #0075d2;
}

.roulette-loading p {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
</style>

<style scoped>
.card {
  margin-top: 20px;
}

.swal2-html-container {
  margin-top: 0 !important;
}

.swal2-image {
  margin-bottom: 0 !important;
}

.premios-container {
  padding: 20px;
}
</style>
